import store from "../../store";
import { updateDocumentComponentAction as updateSecInDocAction } from "../../actions/DocumentActions";
import { updateDocumentComponentService as updateSecInDocService } from "../../actions/DocumentActions/services";

/* eslint-disable import/prefer-default-export */
export const updateSecInDocReduxAndBackend = (updatedSection, oldSection) => {
  store.dispatch(updateSecInDocAction(updatedSection));
  updateSecInDocService(updatedSection)
    .then(() => {})
    .catch(() => {
      store.dispatch(updateSecInDocAction(oldSection));
    });
};



// WEBPACK FOOTER //
// ./src/components/DocumentItems/methods.js